import React from 'react';
import { renderToString } from 'react-dom/server';
import './PlayersGrid.css';
import PlayersGridItem from '../PlayersGridItem';
import Box from '../../../../components/Box';

const $ = window.$;

class PlayersGrid extends React.Component {
  componentDidMount() {
    this.initSortable();
  }

  shouldComponentUpdate(nextProps) {
    if (!this.props.enableSorting) {
      return true;
    }

    // Force as few renders as possible,
    // only update on add/remove player,
    // the sortable plugin will be responsible for all other updates.
    return JSON.stringify(this.getCurrentGridState()) !==
      JSON.stringify(nextProps.grid);
  }

  componentWillUpdate() {
    this.destroySortable();
  }

  render() {
    return (
      <Box className="players-grid">
        <div ref="dummy" />
      </Box>
    );
  }

  componentDidUpdate() {
    this.initSortable();
  }

  componentWillUnmount() {
    this.destroySortable();
  }

  getPlayerItems(columnIndex) {
    const { grid, playersData, enableSorting } = this.props;

    return grid[columnIndex].map(playerId => (
      <li id={ `player_${playerId}` }
          key={ playerId }>
        <PlayersGridItem id={ playerId }
                         data={ playersData[playerId] || {} }
                         enableSorting={ enableSorting } />
      </li>
    ));
  }

  getSortableColumnsHtml() {
    let columns = [];

    for (let i = 1; i <= 5; i++) {
      columns.push(
        <td key={ `sortable${i}` } style={{ width: '20%' }}>
          <ul key={ `sortable${i}` }
              id={ `sortable${i}` }
              className="connectedSortable">
            { this.getPlayerItems(i) }
          </ul>
        </td>
      )
    }

    return renderToString(
      <table className="table">
        <tbody>
          <tr>
            { columns }
          </tr>
        </tbody>
      </table>
    ).replace(/img/g,
      "img onerror=\"this.src='https://s3.amazonaws.com/s4usitesimages/images/anon-avatar.png'\"");
  }

  initSortable() {
    const { onChange, onRemovePlayer, enableSorting } = this.props;

    this.$dummy = $(this.refs.dummy);
    this.$dummy.after(this.getSortableColumnsHtml());

    if (enableSorting) {
      this.$sortables =
        $("#sortable1, #sortable2, #sortable3, #sortable4, #sortable5");

      this.$sortables.sortable({
        connectWith: ".connectedSortable",
        stop: (event, ui) => {
          const newState = this.getCurrentGridState();
          if (JSON.stringify(newState) !== JSON.stringify(this.props.grid)) {
            onChange(newState);
          }
        }
      }).disableSelection();

      $('.remove-player').on('click', e => {
        e.stopPropagation();
        let playerId = parseInt(e.target.id.replace('btn_remove_player_', ''), 10);
        onRemovePlayer(playerId);
      });
    }
  }

  destroySortable() {
    // Clean up the mess when the component unmounts
    if (this.props.enableSorting) {
      $('.remove-player').off('click');
      this.$sortables.sortable('destroy');
    }
    this.$dummy.next().remove();
  }

  getCurrentGridState() {
    let state = {};
    [1, 2, 3, 4, 5].map(i => {
      return state = {
        ...state,
        [i]: $(`#sortable${i}`).sortable("toArray").map(
          n => parseInt(n.replace('player_', ''), 10)
        )
      }
    });
    return state;
  }
}

export default PlayersGrid;



// WEBPACK FOOTER //
// ./src/features/scout-report/components/PlayersGrid/PlayersGrid.js